import React from 'react';

const FormPage = React.lazy(() => import('./FormPage' /* webpackChunkName: "Form" */));
export default function FormInitializer() {
    return <FormPage />;
}
